import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
export function ProductBuild() {
    return _jsx(Outlet, {});
}
